import React from 'react';
import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons';
import { PALETTE } from '../../../../common/styles/palette';
interface IProps {
    sort?: string;//'up' | 'down'
    onClick: () => any;//'up' | 'down'
}
const selected = PALETTE.Secondary;
const unselected = '3a3f53';

export const SortIcon = (props: IProps) => {
    return (<div onClick={props.onClick}>
        <ArrowDropDown style={props.sort === 'down' ? { fill: selected, marginRight: '-13px' } : props.sort === 'up' ? { fill: unselected, marginRight: '-13px' } : { fill: unselected, marginRight: '-13px' }} />
        <ArrowDropUp style={props.sort === 'up' ? { fill: selected } : props.sort === 'down' ? { fill: unselected } : { fill: unselected }} />
    </div>
    )
}